import type { RootState } from '..';

export const selectFetchInvoiceLoading = (state: RootState) =>
  state.invoice.fetchLoading;

export const selectCreateInvoiceLoading = (state: RootState) =>
  state.invoice.createLoading;

export const selectExtractInvoiceDataLoading = (state: RootState) =>
  state.invoice.extractLoading;

export const selectDeleteInvoiceLoading = (state: RootState) =>
  state.invoice.deleteLoading;

export const selectRefreshInvoice = (state: RootState) => state.invoice.refresh;

export const selectInvoiceData = (state: RootState) =>
  state.invoice.invoiceData;

export const selectInvoiceError = (state: RootState) => state.invoice.error;

export const selectInvoice = (state: RootState) => state.invoice.invoice;

export const selectInvoiceList = (state: RootState) =>
  state.invoice.invoiceList;
